function takeScreenshot() {
	if (window && typeof window.callPhantom === 'function') {
		window.callPhantom({ ready: true })
	}
}

export default takeScreenshot
